<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">{{itemSetting.action.label[activeLang]}}</div>
    <DatePicker
      :masks="{input: dateFormat.toUpperCase()}"
      :value="null"
      :attributes="calendarAttr"
      :disabled-dates="disabledDates">
      <template v-slot="{ inputValue, togglePopover }">
        <div>
          <button
            class="btn btnWhite btnFull btnCalendar"
            :style="valueStyle"
            @click="togglePopover()">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20">
              <path d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"></path>
            </svg>
            <span class="dateLabel">{{inputValue || '-'}}</span>
          </button>
        </div>
      </template>
    </DatePicker>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment'

export default {
  name: 'CalendarModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  components: {
  },
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    dateFormat () {
      return this.$store.getters['setting/getDateFormat']
    },
    disabledDates () {
      const weekday = this.itemSetting.action.dayOfWeek.filter(x => !x.available).map(x => x.weekday)
      const hasTerm = this.itemSetting.action.hasTerm
      const disabledDays = this.itemSetting.action.disabledDays.map(x => x.id)
      const allowedToday = this.itemSetting.action.allowedToday
      const allowedPast = this.itemSetting.action.allowedPast
      const today = moment()
      const dateFrom = moment(this.itemSetting.action.dateFrom)
      const rangeFrom = allowedPast // 과거 선택 가능?
        ? hasTerm // 기간 설정?
          ? dateFrom.add(-1, 'days').toISOString()
          : null
        : hasTerm // 기간 설정?
          ? today.isAfter(dateFrom, 'days') // 오늘 지남?
            ? today.add(-1, 'days').toISOString()
            : dateFrom.add(-1, 'days').toISOString()
          : today.add(-1, 'days').toISOString()
      const rangeTo = moment(this.itemSetting.action.dateTo).add(1, 'days').toISOString()
      let dates = [{ weekdays: weekday }]
      if (!allowedPast || hasTerm) {
        dates.push({
          start: null,
          end: rangeFrom
        })
      }
      if (hasTerm) {
        dates.push({
          start: rangeTo,
          end: null
        })
      }
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      if (!allowedToday) {
        dates.push(new Date())
      }
      return dates
    }
  },
  data () {
    return {
      calendarAttr: [
        {
          bar: 'blue',
          dates: new Date()
        }
      ]
    }
  },
  methods: {
    toFormat (date) {
      const iso = typeof (date) === 'string' ? date : date.toISOString()
      return DateTime.fromISO(iso).toFormat(this.dateFormat)
    }
  }
}
</script>
